//#region ../../node_modules/@turf/meta/dist/esm/index.js
function e(t, n, r) {
	if (t !== null) for (var i, a, o, s, c, l, u, d = 0, f = 0, p, m = t.type, h = m === "FeatureCollection", g = m === "Feature", _ = h ? t.features.length : 1, v = 0; v < _; v++) {
		u = h ? t.features[v].geometry : g ? t.geometry : t, p = u ? u.type === "GeometryCollection" : !1, c = p ? u.geometries.length : 1;
		for (var y = 0; y < c; y++) {
			var b = 0, x = 0;
			if (s = p ? u.geometries[y] : u, s !== null) {
				l = s.coordinates;
				var S = s.type;
				switch (d = r && (S === "Polygon" || S === "MultiPolygon") ? 1 : 0, S) {
					case null: break;
					case "Point":
						if (n(l, f, v, b, x) === !1) return !1;
						f++, b++;
						break;
					case "LineString":
					case "MultiPoint":
						for (i = 0; i < l.length; i++) {
							if (n(l[i], f, v, b, x) === !1) return !1;
							f++, S === "MultiPoint" && b++;
						}
						S === "LineString" && b++;
						break;
					case "Polygon":
					case "MultiLineString":
						for (i = 0; i < l.length; i++) {
							for (a = 0; a < l[i].length - d; a++) {
								if (n(l[i][a], f, v, b, x) === !1) return !1;
								f++;
							}
							S === "MultiLineString" && b++, S === "Polygon" && x++;
						}
						S === "Polygon" && b++;
						break;
					case "MultiPolygon":
						for (i = 0; i < l.length; i++) {
							for (x = 0, a = 0; a < l[i].length; a++) {
								for (o = 0; o < l[i][a].length - d; o++) {
									if (n(l[i][a][o], f, v, b, x) === !1) return !1;
									f++;
								}
								x++;
							}
							b++;
						}
						break;
					case "GeometryCollection":
						for (i = 0; i < s.geometries.length; i++) if (e(s.geometries[i], n, r) === !1) return !1;
						break;
					default: throw Error("Unknown Geometry Type");
				}
			}
		}
	}
}
//#endregion
//#region ../../node_modules/@turf/bbox/dist/esm/index.js
function t(t, n = {}) {
	if (t.bbox != null && !0 !== n.recompute) return t.bbox;
	let r = [
		Infinity,
		Infinity,
		-Infinity,
		-Infinity
	];
	return e(t, (e) => {
		r[0] > e[0] && (r[0] = e[0]), r[1] > e[1] && (r[1] = e[1]), r[2] < e[0] && (r[2] = e[0]), r[3] < e[1] && (r[3] = e[1]);
	}), r;
}
var n = t;
//#endregion
export { n as t };
